export const photoCaptureResetContextReducer = (state, action) => {
    return Object.assign(Object.assign({}, state), { isContextUpdated: false });
};
//# sourceMappingURL=photoCaptureResetContextReducer.js.map